import { connect } from 'react-redux';
import LoadMore from '../../../components/common/LoadMore';
import { loadPreviousWeek } from '../actions';
import { isLoadingMoreChunks } from '../selectors';

const mapStateToProps = state => ({
  showSpinner: isLoadingMoreChunks(state)
});

const mapDispatchToProps = {
  onClick: loadPreviousWeek
};

export default connect(mapStateToProps, mapDispatchToProps)(LoadMore);
